/**
 * Frases-exemplo do passo 2 do registro.
 * Curadas do README §7.3 + §4.3 — tom cerimonial, sem urgência.
 */
export const MESSAGE_SUGGESTIONS: string[] = [
  'Pela minha filha, sonhe alto',
  'Brasil Hexa Feminino',
  'Para todas que vieram antes',
  'Por um futuro com mais delas no campo',
  'Da arquibancada para a história',
  'Para minha treinadora',
];
